/**
 * Öffnet den Cookie-Banner von Shopify wieder (ENT-081).
 *
 * Der Banner selbst kommt aus Shopify (Einstellungen, Kundendatenschutz)
 * und schreibt die Wahl in die Customer Privacy API. Meta-Pixel und
 * Google Analytics hängen über die offiziellen Apps daran, nicht an
 * diesem Theme. Hier steht nur der Rückweg: widerrufen muss so leicht
 * sein wie zustimmen, deshalb ein Knopf im Fuß jeder Seite.
 *
 * Der Knopf ist immer sichtbar. Shopify lädt den Banner asynchron, oft
 * erst nach diesem Skript: beim Klick wird deshalb bis zu drei Sekunden
 * auf window.privacyBanner gewartet. Kommt er nicht (Theme-Editor,
 * Blocker, Banner im Admin abgeschaltet), führt der Knopf zur
 * Datenschutzerklärung des Shops, dort steht, wie man widerspricht.
 */
(() => {
  const WARTEZEIT_MS = 3000;
  const TAKT_MS = 100;

  const banner = () =>
    typeof window.privacyBanner?.showPreferences === 'function' ? window.privacyBanner : null;

  const warteAufBanner = () =>
    new Promise((fertig) => {
      const start = Date.now();
      const pruefen = () => {
        const gefunden = banner();
        if (gefunden || Date.now() - start >= WARTEZEIT_MS) {
          fertig(gefunden);
          return;
        }
        window.setTimeout(pruefen, TAKT_MS);
      };
      pruefen();
    });

  const oeffnen = async (ereignis) => {
    const knopf = ereignis.currentTarget;
    if (knopf.getAttribute('aria-busy') === 'true') return;

    knopf.setAttribute('aria-busy', 'true');
    const gefunden = banner() ?? (await warteAufBanner());
    knopf.removeAttribute('aria-busy');

    if (gefunden) {
      try {
        gefunden.showPreferences();
        return;
      } catch {
        /* Fällt durch auf die Datenschutzerklärung. */
      }
    }
    window.location.assign(knopf.dataset.ffDatenschutz || '/policies/privacy-policy');
  };

  for (const knopf of document.querySelectorAll('[data-ff-cookie-einstellungen]')) {
    knopf.addEventListener('click', oeffnen);
  }
})();
